import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ScrollToTopComponent } from './components/scroll-to-top/scroll-to-top.component';
import { LanguageService } from './services/language.service';
import { PageSeo, SeoService } from './services/seo.service';
import { ThemeService } from './services/theme.service';

@Component({
   selector: 'app-root',
   standalone: true,
   imports: [
      RouterOutlet,
      ScrollToTopComponent,
   ],
   templateUrl: './app.component.html',
   styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
   title = 'oopsy-app';

   constructor(
      private language: LanguageService,
      private router: Router,
      private route: ActivatedRoute,
      private seo: SeoService,
      // Applied at startup; the toggle itself is in the navbar
      _theme: ThemeService,
   ) {
      this.language.init();
   }

   /**
    * Re-title the document on every completed navigation.
    *
    * Walks to the deepest activated route so a child's `seo` data wins over its
    * parent's. Pages whose title depends on data they still have to load (a
    * search, an offer's price history) apply this route-level default first and
    * overwrite it from their own component once the data is in — the default is
    * what a crawler sees if the load fails, so it has to be true on its own.
    */
   ngOnInit(): void {
      this.router.events.pipe(
         filter((event) => event instanceof NavigationEnd),
         map(() => {
            let route = this.route;
            while (route.firstChild) route = route.firstChild;
            return route;
         }),
         mergeMap((route) => route.data),
      ).subscribe((data) => {
         const seo = data['seo'] as PageSeo | undefined;
         if (seo) this.seo.apply({ ...seo, path: seo.path ?? this.router.url });
      });
   }
}
